export default {
    eyebrow: "Contatti",
    title: "Raccontaci cosa ti serve",
    description: "Richiedi una demo o invia una richiesta generale. Il nostro team ti rispondera' a breve.",
    backToLanding: "Torna alla landing",
    help: {
        title: "Risposta rapida",
        description: "Analizziamo ogni richiesta e rispondiamo appena possibile.",
    },
    fields: {
        fullName: {
            label: "Nome completo",
            placeholder: "Il tuo nome e cognome",
            hint: "Usa il tuo nome reale per facilitare il follow-up.",
        },
        workEmail: {
            label: "Email aziendale",
            placeholder: "nome@azienda.com",
            hint: "Usa un indirizzo email business.",
        },
        company: {
            label: "Azienda",
            placeholder: "Nome della tua azienda",
            hint: "L'azienda che rappresenti.",
        },
        requestType: {
            label: "Tipo richiesta",
            options: {
                demo: "Richiesta demo",
                general: "Richiesta generale",
            },
        },
        relationshipType: {
            label: "Il tuo ruolo (opzionale)",
            placeholder: "Seleziona il tuo ruolo",
            options: {
                shipper: "Shipper",
                receiver: "Receiver",
                notify_party: "Notify party",
                freight_forwarder: "Freight forwarder",
                carrier: "Carrier",
                customs_broker: "Customs broker",
                port_authority: "Port authority",
                insurance_provider: "Insurance provider",
                inspection_agency: "Inspection agency",
                regulatory_authority: "Regulatory authority",
                land_transport: "Land transport",
                supplier: "Fornitore",
                customer: "Cliente",
                other: "Altro",
            },
        },
        message: {
            label: "Messaggio",
            placeholder: "Condividi contesto, obiettivi o domande...",
            hint: "Massimo 2000 caratteri.",
        },
        privacyConsent: {
            label: "Acconsento al trattamento dei miei dati per finalita' di contatto.",
            hint: "Obbligatorio per inviare il modulo.",
        },
    },
    validation: {
        fullNameRequired: "Il nome completo e' obbligatorio.",
        workEmailRequired: "L'email aziendale e' obbligatoria.",
        workEmailInvalid: "Inserisci un indirizzo email valido.",
        companyRequired: "L'azienda e' obbligatoria.",
        messageRequired: "Il messaggio e' obbligatorio.",
        messageTooLong: "Il messaggio deve avere massimo 2000 caratteri.",
        privacyConsentRequired: "Devi accettare il consenso privacy per continuare.",
    },
    submit: {
        cta: "Invia richiesta",
        successTitle: "Richiesta inviata",
        successDescription: "Grazie. Abbiamo ricevuto la tua richiesta e ti contatteremo presto.",
        successToast: "Richiesta di contatto inviata con successo.",
        backHome: "Vai alla landing",
    },
};
